const NotAvailable = 'NotAvailable';
const WriteError = 'WriteError';

export const shouldRejectCopy = () => ('clipboard' in navigator ? false : NotAvailable);
const copyText = value =>
  new Promise((resolve, reject) => {
    if ('clipboard' in navigator) {
      navigator.clipboard
        .writeText(value)
        .then(() => resolve(value))
        .catch(() => reject(WriteError));
    } else {
      reject(NotAvailable);
    }
  });

export default copyText;
